module.exports = __webpack_public_path__ + "static/media/34DSS2.1bf45c32.jpg";